import React, { useState } from 'react'
import { FlatList } from 'react-native';
import Icons from './Icons';
import { useColors } from '../constants/useColors';
import { Button, Text, View } from './Themed';

type DropdownProps = {
    selected_value:string,
    invalid?: boolean,
    errors?:string[],
    dropdown_options: { value:string, eligible_options: string[] }[]
    read_only?:boolean
    onOptionSelect: (option:string) => void
}
const DropDown = ({ invalid, errors, read_only, selected_value, dropdown_options, onOptionSelect }:DropdownProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);
    let options:string[] = []
    
    if(dropdown_options){
        dropdown_options.map(o => {
            options = options.concat(o.eligible_options)
        })
    }


    const handleOptionSelect = (option:string) => {
        setExpanded(false);
        onOptionSelect(option)
    }


    const renderErrors = (data : { item:string, index:number }) => {
        return (
            <Text style={{ margin:4 }} size={12} color={Colors.text.error} weight='regular'>{data.item}</Text>
        )
    }


    const renderOptions = (data: { item: string, index:number }) => {
        const last_item = data.index == options.length - 1 ? true : false
        return (
            <Button transparent style={{ borderRadius:0, paddingTop:10, paddingBottom:last_item?0:10, borderBottomWidth:last_item?0:1, borderColor:Colors.borders.light }} onPress={() => handleOptionSelect(data.item)}>
                <Text size={14} theme='description'>{data.item}</Text>
            </Button>
        )
    }

    return (
        <View transparent>
            <View float style={{ borderRadius:8, borderWidth:1, borderColor:invalid?Colors.text.error:Colors.borders.light }}>
                <Button transparent disabled={read_only} style={{ flexDirection:'row', alignItems:'center', padding:10 }} onPress={() => setExpanded(!expanded)}>
                    <Text style={{ flex:1, marginRight:6 }} size={14} theme='h2'>{selected_value && selected_value != '' ? selected_value : 'Select Value'}</Text>
                    {!read_only ?
                    <Icons.ChevronIcon
                        direction={expanded?'up':'down'}
                        color={Colors.text.h1}
                        size={8}
                    />
                    :<></>}
                </Button>
                {expanded ?
                <View transparent style={{padding:10 }}>
                    <FlatList
                        data={options}
                        renderItem={renderOptions}
                    />
                </View>
                :<></>}
            </View>
            {invalid && errors && errors.length > 0 ?
            <FlatList
                data={errors}
                renderItem={renderErrors}
                keyExtractor={(item) => item}
            />
            :<></>}
        </View>
    )
}

export default DropDown
